import axios from "axios";
import { GetSearchRequestType } from "../types/common.type";

import { apiBase } from './apiBase';
export const getSearchResult = ({ keyword, page, size, token, region, sector }: GetSearchRequestType): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        const params: GetSearchRequestType = { keyword: keyword, page: page, size: size, token: token };
        if (region && region.trim() !== "") {
            params.region = region;
        }
        if (sector && sector.trim() !== "") {
            params.sector = sector;
        }

        axios
            .get(`${apiBase()}/search/`, {
                params: params,
            })
            .then((res) => {
                if (res.data.data) {
                    resolve(res.data.data);
                } else return;
            }
            )
            .catch((err) => {
                reject(err);
            });
    });
};